// react
import { useCallback } from 'react';

// components
import { FormIntroPage } from '@karehero/llama/pwa/pages/FormIntroPage/FormIntroPage';

// hooks
import { useCareProfile } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';
import { CareProfileCategoryID } from '@karehero/models';

// router
import { ROUTES } from 'router';

// store
import { useSelector, dispatch } from 'store';
import { getAccount } from 'store/slices/iamSlice';
import { newToast } from 'store/slices/uiSlice';

/**
 * CarePlan shows the care assessment intro page.
 */
export const CarePlan = () => {
  // hooks
  const goBack = useGoBack();
  const { handleStart, careProfileID } = useCareProfile({
    categoryID: CareProfileCategoryID.CareAssessment,
  });
  const account = useSelector(getAccount);
  const isAdminWithoutCareProfile =
    account?.accountRole?.name === 'KareHero Administrator' && !careProfileID;

  const onStart = useCallback(() => {
    if (isAdminWithoutCareProfile) {
      dispatch(
        newToast({
          title: 'Please select a care circle first',
          variant: 'warning',
          action: {
            label: 'Select care circle',
            href: ROUTES.ADMIN_CARE_CIRCLE_MANAGE,
          },
        }),
      );
      return;
    }
    handleStart();
  }, [isAdminWithoutCareProfile, handleStart]);

  return (
    <FormIntroPage
      onBack={goBack}
      title='Care assessment'
      description="Build a detailed picture of your loved one's care needs so our experts can find the best care services for your situation."
      items={[
        {
          icon: 'file-contract',
          text: 'Answer care and health questions about the person requiring care.',
        },
        {
          icon: 'check-circle',
          text: 'Our experts will review and research suitable care services.',
        },
        {
          icon: 'home',
          text: "We'll send you a Shortlist of services, and help you secure your top choice.",
        },
      ]}
      infoText="We've helped thousands of families claim funding they didn't realise they were eligible for."
      onStart={onStart}
      muxPlaybackId='4baJtvnkmwQS8incpHlrIGMXG9AI00QKeyBcrWqu64cg'
      muxThumbnailTime={0}
    />
  );
};

CarePlan.displayName = 'CarePlanStart';
export default CarePlan;
